module.exports = __webpack_public_path__ + "static/media/baseball-autograph.e6969089.mov";